export const environment = {
    app: 'production',
    // graphqlUri: 'http://localhost:5001/studio/graphql',
    awsRegion: 'ap-south-1',
    bucketName: 'zenbasket-prod',
    secretKey: 'uOTD2R7B8mXQeVKNffUgXFahfioXqn',
    graphqlUri: 'http://zbapps.zenbasket.in/studio/graphql',
    zbbundleUri: 'https://prod.in.ssr.graphql.getzenbasket.com/graphql',
    zenbasketUrl: "https://dashboard.getzenbasket.com",
    awsUrl: 'https://in.images.getzenbasket.com/',
  //  mediaBaseUrl: 'https://media.getzenbasket.com/prodIn/',
    backendUrl: 'https://zbapps.zenbasket.in/',
    zbStorefrontUrl: 'https://storefront.getzenbasket.com',
    region: 'in',
    backendServerConfigUrl: 'https://useast1.api.getzenbasket.com/checkdomain/v1/config',
    mediaBaseUrl: 'https://media.finicor.com/',
    imageMediaBaseUrl: 'https://media.finicor.com/cdn-cgi/image/mode=image',
    videoMediaBaseUrl: 'https://media.finicor.com/cdn-cgi/media/mode=video/',
    awsFileUrl: 'https://in.images.getzenbasket.com/'
};